// import {useEffect, useState} from 'react'
// import {useLocation} from 'react-router-dom'
import {useIntl} from 'react-intl'

export default function BreadCrumb({currentPage}) {
  // const [subPage, setSubPage] = useState({
  //   key: '',
  //   value: '',
  // })
  // let location = useLocation()
  const intl = useIntl()

  // useEffect(() => {
  //   let param = location.search?.split('=')[1]
  //   let paramKey = location.search?.split('=')[0]?.split('?')[1]
  //   if (!param || !paramKey) return
  //   setSubPage({
  //     key: paramKey,
  //     value: param,
  //   })
  // }, [location])

  return (
    <div className='page-title d-flex flex-column justify-content-center gap-1 me-3'>
      <h1 className='page-heading d-flex flex-column justify-content-center text-dark fw-bold fs-3 m-0'>
        {currentPage}
      </h1>
      <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0'>
        <li className='breadcrumb-item text-muted'>
          <a href='/dashboard' className='text-muted text-hover-primary'>
            {intl.formatMessage({id: 'MENU.HOME'})}
          </a>
        </li>
        <li className='breadcrumb-item'>
          <span className='bullet bg-gray-400 w-5px h-2px'></span>
        </li>
        <li className='breadcrumb-item text-muted'>{intl.formatMessage({id: 'APP_NAME'})}</li>
        {/* {subPage && subPage.key && subPage.value && (
          <>
            <li className='breadcrumb-item'>
              <span className='bullet bg-gray-400 w-5px h-2px'></span>
            </li>
            <li className='breadcrumb-item text-muted'>
              <Link
                to={`/${subPage?.key}/${subPage?.value}`}
                className='text-muted text-hover-primary'
              >
                {subPage?.key === 'sId'
                  ? intl.formatMessage({id: 'STORE.DETAIL'})
                  : intl.formatMessage({id: 'MEMBER.DETAIL'})}
              </Link>
            </li>
          </>
        )} */}
        <li className='breadcrumb-item'>
          <span className='bullet bg-gray-400 w-5px h-2px'></span>
        </li>
        <li className='breadcrumb-item text-dark'>{currentPage}</li>
      </ul>
    </div>
  )
}
